// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/lib/stayPhase.ts
// 🔧 PURPOSE: In che momento del soggiorno siamo, dalle sole date della
//             prenotazione. Serve alla Home per scegliere le due card
//             "giuste": lontano dall'arrivo, negli ultimi sette giorni, il
//             giorno dell'arrivo, durante, il giorno della partenza, dopo.
// ============================================

export type HomePhase = 'far' | 'soon' | 'arrival' | 'stay' | 'checkout' | 'after';

/** "YYYY-MM-DD" (o ISO) → giorno locale a mezzanotte. */
const dayOf = (value?: string | null): Date | null => {
  if (!value) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  if (!m) return null;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
};

export interface StayTiming {
  phase: HomePhase;
  /** Giorni all'arrivo (negativo dopo l'arrivo). */
  daysToCheckIn: number;
  /** Giorni alla partenza. */
  daysToCheckOut: number;
}

export function stayTiming(
  booking: { checkIn?: string | null; checkOut?: string | null } | null | undefined,
  now: Date = new Date(),
): StayTiming | null {
  const ci = dayOf(booking?.checkIn);
  const co = dayOf(booking?.checkOut);
  if (!ci || !co) return null;
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const days = (a: Date, b: Date) => Math.round((a.getTime() - b.getTime()) / 86400000);
  const daysToCheckIn = days(ci, today);
  const daysToCheckOut = days(co, today);
  let phase: HomePhase;
  if (daysToCheckIn > 7) phase = 'far';
  else if (daysToCheckIn > 0) phase = 'soon';
  else if (daysToCheckIn === 0) phase = 'arrival';
  else if (daysToCheckOut > 0) phase = 'stay';
  else if (daysToCheckOut === 0) phase = 'checkout';
  else phase = 'after';
  return { phase, daysToCheckIn, daysToCheckOut };
}
